// Live Reviews Feed — pulls real 4-5★ claim feedback from /api/reviews/public
import React, { useEffect, useState } from "react";
import { Star, Quote } from "lucide-react";
import { api } from "@/lib/api";

export default function ReviewsFeed() {
  const [rows, setRows] = useState([]);

  useEffect(() => {
    api.get("/reviews/public?limit=6").then((r) => setRows(r.data || [])).catch(() => {});
  }, []);

  if (rows.length === 0) return null;

  return (
    <div data-testid="reviews-feed" className="grid grid-cols-1 md:grid-cols-3 gap-4">
      {rows.map((r, i) => (
        <div
          key={r.case_number || i}
          data-testid={`review-card-${i}`}
          className="bg-card border border-border rounded-2xl p-6 relative flex flex-col"
        >
          <Quote className="w-6 h-6 text-secondary/40 shrink-0" />
          <div className="mt-3 flex items-center gap-1">
            {[1, 2, 3, 4, 5].map((n) => (
              <Star
                key={n}
                className={`w-4 h-4 ${n <= r.rating ? "text-secondary fill-secondary" : "text-muted-foreground/30"}`}
              />
            ))}
          </div>
          <div className="mt-3 text-sm text-foreground/90 flex-1">"{r.note}"</div>
          <div className="mt-4 text-xs text-muted-foreground border-t border-border pt-3 flex items-center justify-between">
            <span className="font-medium text-foreground/70">— {r.name}</span>
            <span className="text-[10px] font-mono opacity-60">{r.case_number}</span>
          </div>
        </div>
      ))}
    </div>
  );
}
